import { z } from 'zod';

export const UserDetailsSchema = z.object({
  user_name: z.string(),
  phone_number: z.string(),
  country_code: z.string(),
  email: z.string().optional()
});
export type UserDetailsType = z.infer<typeof UserDetailsSchema>;

export const RazorpaySmartCollectDetailsSchema = z.object({
  bank_account_number: z.string(),
  ifsc_code: z.string(),
  bank_name: z.string().optional(),
  merchant_name: z.string()
});
export type RazorpaySmartCollectDetailsType = z.infer<
  typeof RazorpaySmartCollectDetailsSchema
>;

// Get Installment Order Payment Details
export const GetInstallmentOrderPaymentDetailsRequestSchema = z.object({
  installment_order_id: z.string()
});
export type GetInstallmentOrderPaymentDetailsRequestType = z.infer<
  typeof GetInstallmentOrderPaymentDetailsRequestSchema
>;

export const GetInstallmentOrderPaymentDetailsResponseSchema = z.object({
  payments: z.array(
    z.object({
      payment_id: z.string(),
      payment_ref_no: z.string(),
      payment_created_datetime: z.string(),
      payment_status: z.string(),
      payment_amount: z.number()
    })
  )
});
export type GetInstallmentOrderPaymentDetailsResponseType = z.infer<
  typeof GetInstallmentOrderPaymentDetailsResponseSchema
>;

// Create Installment
export const CustomizableInstallmentDetailsSchema = z.object({
  amount: z.number(),
  next_installment_details: z
    .object({
      next_installment_datetime: z.string()
    })
    .optional()
});
export type CustomizableInstallmentDetailsType = z.infer<
  typeof CustomizableInstallmentDetailsSchema
>;

export const PeriodicInstallmentDetailsSchema = z.object({
  amount: z.number()
});
export type PeriodicInstallmentDetailsType = z.infer<
  typeof PeriodicInstallmentDetailsSchema
>;

export const CreateInstallmentRequestSchema = z.object({
  user_details: UserDetailsSchema.optional(),
  installment_order_id: z.string(),
  payment_service: z.enum(['RAZORPAY', 'JUSPAY']).optional(),
  payment_mode: z.enum(['BANK_TRANSFER', 'DIGITAL_PAYMENT']).optional(),
  customizable_installment_details:
    CustomizableInstallmentDetailsSchema.optional(),
  periodic_installment_details: PeriodicInstallmentDetailsSchema.optional(),
  post_payment_redirection_url: z.string().optional()
});
export type CreateInstallmentRequestType = z.infer<
  typeof CreateInstallmentRequestSchema
>;

export const RazorpayPaymentDetailsSchema = z.object({
  razorpay_order_id: z.string(),
  razorpay_key: z.string()
});
export type RazorpayPaymentDetailsType = z.infer<
  typeof RazorpayPaymentDetailsSchema
>;

export const JuspayPaymentDetailsSchema = z.object({
  payment_link: z.string()
});
export type JuspayPaymentDetailsType = z.infer<
  typeof JuspayPaymentDetailsSchema
>;

export const CreateInstallmentResponseSchema = z.object({
  installment_id: z.string(),
  customer_installment_id: z.string(),
  installment_status: z.string(),
  payment_service: z.string(),
  razorpay_payment_details: RazorpayPaymentDetailsSchema.optional().nullable(),
  juspay_payment_details: JuspayPaymentDetailsSchema.optional().nullable(),
  razorpay_smart_collect_details:
    RazorpaySmartCollectDetailsSchema.optional().nullable()
});
export type CreateInstallmentResponseType = z.infer<
  typeof CreateInstallmentResponseSchema
>;

// Get Installment Status
export const GetInstallmentStatusRequestSchema = z.object({
  customer_installment_id: z.string()
});
export type GetInstallmentStatusRequestType = z.infer<
  typeof GetInstallmentStatusRequestSchema
>;

export const GetInstallmentStatusResponseSchema = z.object({
  payment_id: z.string(),
  payment_status: z.string(),
  installment_status: z.string(),
  payment_service: z.string(),
  payment_service_order_id: z.string().optional(),
  payment_service_key: z.string().optional()
});
export type GetInstallmentStatusResponseType = z.infer<
  typeof GetInstallmentStatusResponseSchema
>;

// Cancel Installment
export const CancelInstallmentRequestSchema = z.object({
  installment_id: z.string(),
  cancelled_reason: z.string().optional()
});
export type CancelInstallmentRequestType = z.infer<
  typeof CancelInstallmentRequestSchema
>;

export const SuccessResponseSchema = z.object({});
export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;
